// GiftsTitle
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const colors = {
  a: '#412191', // purple
  b: '#27850A', // green
};

const Wrapper = styled.div`
  padding: 50px 0;
  @media (min-width: 660px) {
    padding: 80px 0 90px 0;
  }
  h2 {
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
    span {
      color: ${props => (props.secondary ? colors.a : colors.b)};
    }
    h3 {
      margin: 10px 0 0 0;
      letter-spacing: 0.18rem;
      padding: 0 1.5vw;
    }
  }
`;

function GiftsMoreTitle({ className = '', ...props }) {
  const classNames = [
    'gifts-gifts-title uk-flex uk-flex-column uk-flex-middle uk-background-default ',
    className,
  ].join(' ');
  return (
    <Wrapper className={classNames}>
      <h2>
        <span className="uk-text-green">{props.titlea}</span> {props.titleb}
      </h2>
      <h3
        className="uk-text-times uk-text-center uk-text-uppercase uk-text-normal uk-text-dark-gray"
        data-uk-scrollspy="cls:uk-animation-scale-up delay: 0; repeat: repeat;"
      >
        {props.tagline}
        <span>&#8482;</span>
      </h3>
    </Wrapper>
  );
}

GiftsMoreTitle.propTypes = {
  className: PropTypes.string,
  titlea: PropTypes.string,
  titleb: PropTypes.string,
  tagline: PropTypes.string,
};
export default GiftsMoreTitle;



// WEBPACK FOOTER //
// ./src/features/gifts/GiftsTitle.js